/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';
const baseSchema = z.object({
    createdAt: z.coerce.date().default(() => new Date()),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
}
).strict();
const baseSchemaWithoutDefaults = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
}
).strict();
const relationSchema = z.object({
    listing: z.record(z.string(), z.unknown()),
}
);
const fkSchema = z.object({
    listingId: z.string(),
}
);

/**
* Schema refinement function for applying `@@validate` rules.
*/
export function refineFeaturedListing<T, D extends z.ZodTypeDef>(schema: z.ZodType<T, D, T>) {
    return schema.refine((value: any) => ((value?.endDate) !== undefined ? (((value?.startDate) !== undefined ? ((value?.startDate < value?.endDate)) : true)) : true), { message: "Featured listing end date must be after the start date.", path: ['startDate', 'endDate'], })
        .refine((value: any) => ((value?.startDate) !== undefined ? ((value?.startDate > (new Date()))) : true), { message: "Featured listing start date must be in the future.", path: ['startDate'], })
        .refine((value: any) => ((value?.endDate) !== undefined ? ((value?.endDate > (new Date()))) : true), { message: "Featured listing end date must be in the future.", path: ['endDate'], });
}


/**
 * `FeaturedListing` schema excluding foreign keys and relations.
 */
export const FeaturedListingScalarSchema = baseSchema;


/**
 * `FeaturedListing` schema prior to calling `.refine()` for extensibility.
 */
export const FeaturedListingWithoutRefineSchema = FeaturedListingScalarSchema.merge(fkSchema).merge(relationSchema.partial());


/**
 * `FeaturedListing` schema including all fields (scalar, foreign key, and relations) and validations.
 */
export const FeaturedListingSchema = refineFeaturedListing(FeaturedListingWithoutRefineSchema);


/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
export const FeaturedListingPrismaCreateSchema = refineFeaturedListing(baseSchemaWithoutDefaults.partial().passthrough());


/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
export const FeaturedListingPrismaUpdateSchema = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    startDate: z.coerce.date(),
    endDate: z.coerce.date()
}).partial().passthrough();


/**
 * `FeaturedListing` schema for create operations excluding foreign keys and relations.
 */
export const FeaturedListingCreateScalarSchema = baseSchemaWithoutDefaults.partial({
    createdAt: true, createdById: true, updatedAt: true, updatedById: true, id: true
});


/**
 * `FeaturedListing` schema for create operations prior to calling `.refine()` for extensibility.
 */
export const FeaturedListingCreateWithoutRefineSchema = FeaturedListingCreateScalarSchema.merge(fkSchema);


/**
 * `FeaturedListing` schema for create operations including scalar fields, foreign key fields, and validations.
 */
export const FeaturedListingCreateSchema = refineFeaturedListing(FeaturedListingCreateWithoutRefineSchema);


/**
 * `FeaturedListing` schema for update operations excluding foreign keys and relations.
 */
export const FeaturedListingUpdateScalarSchema = baseSchemaWithoutDefaults.partial();


/**
 * `FeaturedListing` schema for update operations prior to calling `.refine()` for extensibility.
 */
export const FeaturedListingUpdateWithoutRefineSchema = FeaturedListingUpdateScalarSchema.merge(fkSchema.partial());


/**
 * `FeaturedListing` schema for update operations including scalar fields, foreign key fields, and validations.
 */
export const FeaturedListingUpdateSchema = refineFeaturedListing(FeaturedListingUpdateWithoutRefineSchema);

